<template>
  <div
    v-if="reviewOnly || prepareOnly"
    class="
      tw-gap-1
      tw-flex
      tw-items-center
      tw-rounded-lg
      tw-p-2
      tw-bg-sf-neutral-subtle-2
    "
    @click="openModal"
  >
    {{ singleShareMode }}
    <div
      class="
        tw-text-sf-neutral-darker-1
        hover:tw-no-underline hover:tw-text-sf-neutral-darker-1
        focus:tw-no-underline focus:tw-text-sf-neutral-darker-1
        tw-py-0.5 tw-px-2
        sf-btn
        tw-rounded-md
      "
    >
      {{ I18n.t('pulse.sharing.manage_pulse_access') }}
    </div>
  </div>
  <ShareTrigger v-else v-bind="$props"></ShareTrigger>
</template>

<script setup lang="ts">
import ShareTrigger from './share-trigger-async'
import { usePulseShare } from '@app/shared/pinia/share-pulse'
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { PulseShareType } from '@app/shared/types/pulse-share'
import { pulseShareTypes } from '@app/shared/types/pulse-share'

interface Props {
  ledgerId: number
  objectId: number
  isBlockedInitial?: boolean
  sharedObjectName?: string
  mode: PulseShareType
}

const I18n = useI18n()

const props = withDefaults(defineProps<Props>(), {
  sharedObjectName: '',
  isBlockedInitial: false,
})

const pulseShareStore = usePulseShare()
pulseShareStore.setCurrentObjectBlocked(props.isBlockedInitial)
pulseShareStore.refreshPulseSharesData(props.ledgerId, props.objectId)

const prepareOnly = computed(() => {
  return (
    props.mode === pulseShareTypes.REVIEW &&
    pulseShareStore.isShared &&
    !pulseShareStore.isSharedForReview
  )
})

const reviewOnly = computed(() => {
  return (
    props.mode === pulseShareTypes.PREPARE &&
    pulseShareStore.isShared &&
    !pulseShareStore.isSharedForPrepare
  )
})

const singleShareMode = computed(() => {
  const modes = {
    reviewOnly: 'pulse.sharing.review_mode_only',
    prepareOnly: 'pulse.sharing.prepare_mode_only',
  }
  return reviewOnly.value
    ? I18n.t(modes.reviewOnly)
    : prepareOnly.value
    ? I18n.t(modes.prepareOnly)
    : null
})

function openModal() {
  window.modalCitizen.openModalPortal('share-workflow-with-pulse-users-modal')
}
</script>
